module.exports = __webpack_public_path__ + "media/images/assignment_library_help-77a2cb89a8d00b81667b7cbe61a18572.svg";